import { render, staticRenderFns } from "./myExamGrades.vue?vue&type=template&id=0dcf8a1d&scoped=true"
import script from "./myExamGrades.vue?vue&type=script&lang=js"
export * from "./myExamGrades.vue?vue&type=script&lang=js"
import style0 from "./myExamGrades.vue?vue&type=style&index=0&id=0dcf8a1d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcf8a1d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dcf8a1d')) {
      api.createRecord('0dcf8a1d', component.options)
    } else {
      api.reload('0dcf8a1d', component.options)
    }
    module.hot.accept("./myExamGrades.vue?vue&type=template&id=0dcf8a1d&scoped=true", function () {
      api.rerender('0dcf8a1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/examCenterOwn/myExamGrades/myExamGrades.vue"
export default component.exports